import React from "react";
import { Row, Col } from "antd";
import { InputItem } from "../../../components/forms/FormItems";
import AutoCompleteItem from "../../../components/forms/AutoCompleteItem";
import { FormattedMessage } from "react-intl";
import PhoneNumberItem from "../../../components/forms/PhoneNumberItem";
import Surface from "../../../components/layouts/Surface";
import Spacer from "../../../components/layouts/Spacer";
import FormHeader from "../../../components/forms/FormHeader";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";

const ContactInformation = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Surface>
        <FormHeader
          title={<FormattedMessage id="app.organization.contactInformation" />}
        />
        <Row>
          <Col xs={24} sm={24} md={24} lg={21} xl={15} xxl={10}>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <PhoneNumberItem name="phone_number" category="organization" />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <PhoneNumberItem name="phone_number2" category="organization" />
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <PhoneNumberItem name="mobile" category="organization" />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <PhoneNumberItem name="fax_number" category="organization" />
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <InputItem name="email" email={true} category="organization" />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}></div>
            </ResponsiveItemsWrapper>
          </Col>
        </Row>
      </Surface>

      <Surface>
        <FormHeader
          title={<FormattedMessage id="app.organization.address" />}
        />
        <Row>
          <Col xs={24} sm={24} md={24} lg={21} xl={15} xxl={10}>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <AutoCompleteItem
                  name="address.city"
                  category="organization"
                  city={true}
                  required={true}
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <InputItem
                  required={true}
                  name="address.street"
                  category="organization"
                />
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <InputItem
                  name="address.apartment_number"
                  category="organization"
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <InputItem
                  required={true}
                  name="address.house_number"
                  category="organization"
                />
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <div style={{ flex: 1 }}>
                  <InputItem
                    name="address.postal_code"
                    postalCode={true}
                    category="organization"
                  />
                </div>
              </div>
              <div style={{ flex: 1 }}></div>
            </ResponsiveItemsWrapper>
          </Col>

          <Col
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={24}
            xxl={{ span: 12, offset: 2 }}
          ></Col>
        </Row>
      </Surface>
    </div>
  );
};

export default ContactInformation;
